import * as React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { Location } from "../../../interfaces";

interface IProps {
  locations: Location[];
  locationId: string;
  setLocationId: React.Dispatch<React.SetStateAction<string>>;
}

export function LocationSelector({
  locations,
  locationId,
  setLocationId,
}: IProps) {
  const handleChange = (event: SelectChangeEvent) => {
    setLocationId(event.target.value as string);
  };

  return (
    <Box sx={{ width: "100%", maxWidth: "600px" }}>
      <FormControl sx={{ width: "100%" }}>
        <InputLabel id="demo-simple-select-label">Lokacija</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={locationId}
          label="Lokacija"
          onChange={handleChange}
        >
          {locations.map((loc: Location) => (
            <MenuItem value={loc.id} key={loc.id}>
              {loc.address}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
